import { Component, type ErrorInfo, type ReactNode } from "react";
import { recordReactErrorToRum } from "utils/cloudWatchRum";
import SomethingWentWrong from "../SomethingWentWrong";

interface IClientPortalErrorBoundaryProps {
    children: ReactNode;
}

interface IClientPortalErrorBoundaryState {
    hasError: boolean;
}

export class ClientPortalErrorBoundary extends Component<
    IClientPortalErrorBoundaryProps,
    IClientPortalErrorBoundaryState
> {
    constructor(props: IClientPortalErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): IClientPortalErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        recordReactErrorToRum(error, errorInfo.componentStack ?? "");
    }

    render(): ReactNode {
        if (this.state.hasError) {
            return <SomethingWentWrong />;
        }
        return this.props.children;
    }
}
